exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lNXte7vOi40cdiq4BZ2cE {\n  border: 1px solid lightgray;\n  border-radius: 10px;\n  -webkit-box-shadow: 0px 0px 25px -6px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 0px 0px 25px -6px rgba(0, 0, 0, 0.75);\n  box-shadow: 0px 0px 25px -6px rgba(0, 0, 0, 0.75); }\n", "", {"version":3,"sources":["/codebuild/output/src374373112/src/src/common/components/section/section.scss"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,0DAA0D;EAC1D,uDAAuD;EACvD,kDAAkD,EAAE","file":"section.scss","sourcesContent":[".section {\n  border: 1px solid lightgray;\n  border-radius: 10px;\n  -webkit-box-shadow: 0px 0px 25px -6px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 0px 0px 25px -6px rgba(0, 0, 0, 0.75);\n  box-shadow: 0px 0px 25px -6px rgba(0, 0, 0, 0.75); }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"section": "lNXte7vOi40cdiq4BZ2cE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/typings-for-css-modules-loader/lib?{"namedExport":true,"camelCase":true,"modules":true,"sourceMap":true,"importLoaders":2,"localIdentname":"[name]__[local]__[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/common/components/section/section.scss
// module id = 935
// module chunks = 9